import comp from "./AIChatFooter";
export default comp;
